import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import OrganismHero from '~/components/organisms/hero/hero.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentIcon from '~ui/components/icon/icon.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(UiComponentWrapper, { class: 'pricing' }, () => [
    h(UiComponentContainer, { class: 'inner' }, () => [
      h(OrganismHero, {
        alignment: 'center',
        level: 2,
      }, {
        tag: () => props.componentPricingCard.tag,
        heading: () => props.record.title || props.componentPricingCard.title,
        paragraph: () => props.record.text || props.componentPricingCard.text,
      }),
      h(UiComponentWrapper, { class: 'list' }, () => [
        h(UiComponentWrapper, { class: 'item' }, () => [
          h(
            UiComponentHeading,
            { as: 'paragraph', level: 3 },
            () => props.pricing.freeColumnTitle,
          ),
          h(
            UiComponentParagraph,
            { class: 'description' },
            () => `${props.currencySymbol === '$' ? '$' : ''}${
              props.pricing.freeColumnPrice
            }${props.currencySymbol === '€' ? '€' : ''}`,
          ),
          h(
            AtomButton,
            {
              action: props.primaryButton.action,
              label: 'Column Free CTA',
              size: 'l',
              to: props.primaryButton.to,
            },
            () => [
              props.primaryButton.slot,
              h(UiComponentIcon, { type: 'arrow-right' }),
            ],
          ),
        ]),
        h(UiComponentWrapper, { class: 'item' }, () => [
          h(
            UiComponentHeading,
            { as: 'paragraph', level: 3 },
            () => props.pricing.proColumnTitle,
          ),
          h(UiComponentParagraph, { class: 'description' }, () => [
            h('small', props.wording.pricingSectionFrom),
            `${props.currencySymbol === '$' ? '$' : ''}${
              props.currencySymbol === '$'
                ? props.pricing.proColumnPrice[0].priceUsdMonthly
                : props.pricing.proColumnPrice[0].priceEurMonthly
            }${props.currencySymbol === '€' ? '€' : ''}`,
            h('small', () => `/${props.wording.pricingSectionPerMonth}`),
          ]),
          h(
            AtomButton,
            {
              action: props.primaryButton.action,
              label: 'Column Pro CTA',
              size: 'l',
              to: props.primaryButton.to,
            },
            () => [
              props.primaryButton.slot,
              h(UiComponentIcon, { type: 'arrow-right' }),
            ],
          ),
        ]),
        h(UiComponentWrapper, { class: 'item' }, () => [
          h(
            UiComponentHeading,
            { as: 'paragraph', level: 3 },
            () => props.pricing.businessColumnTitle,
          ),
          h(
            UiComponentParagraph,
            { class: 'description' },
            () => props.pricing.businessColumnPrice,
          ),
          h(
            AtomButton,
            {
              action: props.secondaryButton.action,
              label: 'Column Business CTA',
              size: 'l',
              to: '#form-demo',
            },
            () => [
              props.global.contactSales,
              h(UiComponentIcon, { type: 'arrow-right' }),
            ],
          ),
        ]),
        h(UiComponentWrapper, { class: 'item' }, () => [
          h(
            UiComponentHeading,
            { as: 'paragraph', level: 3 },
            () => props.pricing.enterpriseColumnTitle,
          ),
          h(
            UiComponentParagraph,
            { class: 'description' },
            () => props.pricing.enterpriseColumnPrice,
          ),
          h(
            AtomButton,
            {
              action: props.secondaryButton.action,
              label: 'Column Enterprise CTA',
              size: 'l',
              to: '#form-demo',
            },
            () => [
              props.global.contactSales,
              h(UiComponentIcon, { type: 'arrow-right' }),
            ],
          ),
        ]),
      ]),
    ]),
  ])
}

Functional.props = {
  componentPricingCard: {
    required: true,
    type: Object,
  },
  currencySymbol: {
    required: true,
    type: String,
  },
  global: {
    required: true,
    type: Object,
  },
  pricing: {
    required: true,
    type: Object,
  },
  primaryButton: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
  secondaryButton: {
    required: true,
    type: Object,
  },
  wording: {
    required: true,
    type: Object,
  },
}

export default Functional
